<template>
  <div class="text-center px-5 py-10" :class="{'text-vault-danger-400': status === 'error'}">
    <div v-if="status === 'loading'" class="spinner"></div>
    <div v-else-if="status === 'success'" class="success-icon">✓</div>
    <div v-else-if="status === 'error'" class="text-5xl mb-4">⚠️</div>

    <h2 class="m-0 mb-2 text-2xl font-bold">{{ title }}</h2>
    <p v-if="message" class="m-0 mb-4 text-vault-text-secondary">{{ message }}</p>

    <slot name="details"></slot>

    <div v-if="$slots.actions" class="flex justify-center gap-3 mt-4.5 flex-wrap sm:flex-col">
      <slot name="actions"></slot>
    </div>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  status: 'loading' | 'success' | 'error';
  title: string;
  message?: string;
}>();
</script>

<style scoped>
/* Loading Spinner */
.spinner {
  @apply w-11 h-11 mx-auto mb-4 rounded-full border-4 border-vault-blue-400/20;
  border-top-color: rgba(102, 126, 234, 0.8);
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

/* Success Icon */
.success-icon {
  @apply w-16 h-16 rounded-full bg-vault-success-400/15 text-vault-success-500 inline-flex items-center justify-center text-3xl mb-4;
}
</style>
